import React from "react";
import { Route, Routes as Rts } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import "react-toastify/dist/ReactToastify.css";

import HomeLayout from "./HomeLayout";

const Auth = React.lazy(() => import("../features/auth"));

interface RouteProps {
  // Define your prop types here
}

const Routes: React.FC<RouteProps> = (props) => {
  return (
    <Rts>
      <Route path="/" element={<ProtectedRoute />} />
      <Route path="/auth/*" element={<Auth />} />

      {/* <HomeLayout /> */}
      <Route path="/dashboard/*" element={<HomeLayout />} />
    </Rts>
  );
};

export default Routes;
